require('angular/angular.js');

module.exports = window.angular;
